import { allTrackers } from "app/services/track/track";
import createAccountReviewTrackingService from "./factory";

const accountReviewTrackingService = createAccountReviewTrackingService(
    allTrackers.dispatchTrackEvent.bind(allTrackers),
);

export default accountReviewTrackingService;
